/* The Scribble Bot · theme JS (buy box, sticky bar, UGC videos, age tabs). No dependencies.
   Works with Dawn's cart drawer when it is enabled (Theme settings → Cart → Drawer). */
(function () {
  "use strict";

  /* ---------- money ---------- */
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return (fmt || "A${{amount}}")
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
      .replace(/<[^>]+>/g, "");
  }

  /* ---------- cart ---------- */
  function refreshCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("#cartN").forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      });
  }
  function addToCart(variantId, quantity) {
    var drawer = document.querySelector("cart-drawer");
    var notice = document.querySelector("cart-notification");
    var target = drawer || notice;
    var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (target && typeof target.getSectionsToRender === "function") {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) { throw new Error(res.description || res.message || "Could not add to cart"); }
      if (target && typeof target.renderContents === "function") {
        try { target.renderContents(res); } catch (e) { /* drawer markup differs: fall through */ }
      }
      return refreshCount().then(function () { return res; });
    });
  }

  /* ---------- buy box ---------- */
  function initBuy(root) {
    var data = JSON.parse(root.querySelector("[data-sb-buy-data]").textContent);
    var fmt = data.moneyFormat;
    var st = { slide: 0, col: null, tier: 1, per: { 2: [], 3: [] }, variant: null };
    var main = root.querySelector(".gal-img"), count = root.querySelector(".gal-count");
    var thumbs = root.querySelectorAll(".thumb"), dots = root.querySelectorAll(".dots i");
    var swatches = root.querySelectorAll(".swatch");
    var colours = [].map.call(swatches, function (s) { return s.dataset.col; });
    var single = data.single;
    var threshold = +root.dataset.threshold;
    var stockEl = root.querySelector("[data-stock]"), stockN = root.querySelector("[data-stock-n]");
    var atc = root.querySelector(".atc"), atcLabel = root.querySelector("[data-atc-label]");
    var variantInput = root.querySelector("[data-variant-input]");
    var sbar = document.getElementById("sbar-" + root.dataset.section);

    function variantFor(col) { return single.find(function (v) { return v.option1 === col; }) || single[0]; }
    function bundleVariant(n) {
      var list = n === 2 ? data.pair : data.trio;
      var want = st.per[n].map(function (c) { return String(c).toLowerCase(); }).join("|");
      return list.find(function (v) { return (v.options || []).map(function (o) { return String(o).toLowerCase(); }).join("|") === want; })
        || list.find(function (v) { return v.available; }) || list[0];
    }
    function show(i) {
      var n = data.media.length; if (!n) return;
      st.slide = (i + n) % n;
      main.src = data.media[st.slide].src; main.removeAttribute("srcset"); main.alt = data.media[st.slide].alt || "";
      thumbs.forEach(function (b, j) { b.setAttribute("aria-current", j === st.slide ? "true" : "false"); });
      dots.forEach(function (d, j) { d.className = j === st.slide ? "on" : ""; });
      if (count) count.textContent = (st.slide + 1) + " / " + n;
    }
    function mediaIndexFor(variantId) {
      var mid = data.variantMedia[variantId]; if (!mid) return 0;
      var idx = data.media.findIndex(function (m) { return m.id === mid; }); return idx < 0 ? 0 : idx;
    }
    function current() {
      if (st.tier === 1) return { v: variantFor(st.col), qty: 1 };
      return { v: bundleVariant(st.tier), qty: 1 };
    }
    function render() {
      var c = current(), v = c.v;
      st.variant = v;
      root.querySelector("[data-price]").textContent = v ? money(v.price, fmt) : "";
      root.querySelector("[data-ap]").textContent = data.priceLines[st.tier] || "";
      variantInput.value = v ? v.id : "";
      var ok = v && v.available;
      atc.disabled = !ok;
      atcLabel.textContent = ok ? "Add to cart — " + money(v.price, fmt) : "Sold out";
      // low stock: real numbers only, single product's selected colour
      var sv = variantFor(st.col), q = sv ? data.stock[sv.id] : null;
      var showStock = q !== null && q !== undefined && q > 0 && q <= threshold;
      if (stockEl) { stockEl.hidden = !showStock; if (showStock) stockN.textContent = q; }
      if (sbar) {
        sbar.querySelector("[data-sbar-pr]").textContent = v ? (money(v.price, fmt) + " · " + (st.tier === 1 ? st.col : (st.tier + " Scribble Bots"))) : "";
        sbar.querySelector("[data-sbar-img]").src = data.media[mediaIndexFor(sv ? sv.id : 0)] ? data.media[mediaIndexFor(sv ? sv.id : 0)].src : "";
      }
    }
    function renderPer() {
      root.querySelectorAll(".percol").forEach(function (pc) {
        var n = +pc.dataset.n; pc.innerHTML = "";
        st.per[n].forEach(function (c, k) {
          var wrap = document.createElement("span"); wrap.style.cssText = "display:inline-flex;align-items:center;gap:6px";
          wrap.appendChild(document.createTextNode("Robot " + (k + 1)));
          var seg = document.createElement("span"); seg.className = "seg";
          colours.forEach(function (col) {
            var b = document.createElement("button"); b.type = "button"; b.textContent = col;
            b.setAttribute("aria-pressed", col === c ? "true" : "false");
            b.addEventListener("click", function (e) { e.stopPropagation(); st.per[n][k] = col; renderPer(); render(); });
            seg.appendChild(b);
          });
          wrap.appendChild(seg); pc.appendChild(wrap);
        });
      });
    }
    function setTier(n) {
      st.tier = n;
      root.querySelectorAll(".tier").forEach(function (t) { t.setAttribute("aria-checked", +t.dataset.tier === n ? "true" : "false"); });
      render();
    }
    // init state
    st.col = colours[0] || (single[0] && single[0].option1);
    st.per[2] = [colours[0], colours[1] || colours[0]];
    st.per[3] = [colours[0], colours[1] || colours[0], colours[0]];
    thumbs.forEach(function (b, i) { b.addEventListener("click", function () { show(i); }); });
    var prev = root.querySelector(".gal-arrow.prev"), next = root.querySelector(".gal-arrow.next");
    if (prev) prev.addEventListener("click", function () { show(st.slide - 1); });
    if (next) next.addEventListener("click", function () { show(st.slide + 1); });
    var x0 = null, gm = root.querySelector(".gal-main");
    gm.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gm.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(st.slide + (dx < 0 ? 1 : -1)); });
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        st.col = sw.dataset.col;
        swatches.forEach(function (o) { o.setAttribute("aria-pressed", o === sw ? "true" : "false"); });
        var cn = root.querySelector("[data-col-name]"); if (cn) cn.textContent = st.col;
        show(mediaIndexFor(variantFor(st.col).id)); render();
      });
    });
    root.querySelectorAll(".tier").forEach(function (t) { t.addEventListener("click", function () { setTier(+t.dataset.tier); }); });
    renderPer(); render();

    // add to cart (form submit + sticky bar)
    function add() {
      if (!st.variant || !st.variant.available) return;
      atc.classList.add("is-loading"); var was = atcLabel.textContent;
      addToCart(st.variant.id, 1).then(function () {
        atcLabel.textContent = "Added to cart"; setTimeout(function () { atcLabel.textContent = was; atc.classList.remove("is-loading"); }, 1400);
      }).catch(function (err) {
        atc.classList.remove("is-loading"); atcLabel.textContent = err.message || "Couldn’t add — try again"; setTimeout(function () { atcLabel.textContent = was; }, 2500);
      });
    }
    root.querySelector("[data-atc-form]").addEventListener("submit", function (e) { e.preventDefault(); add(); });
    if (sbar) {
      sbar.querySelector("[data-sbar-btn]").addEventListener("click", add);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sbar.classList.toggle("on", past); sbar.setAttribute("aria-hidden", past ? "false" : "true");
        });
      });
      io.observe(atc);
    }
    // buttons elsewhere on the page: data-sb-tier="3" jumps to the buy box with that tier; data-sb-add adds the current selection
    document.querySelectorAll("[data-sb-tier]").forEach(function (b) {
      b.addEventListener("click", function () { setTier(+b.dataset.sbTier); root.scrollIntoView({ behavior: "smooth", block: "start" }); });
    });
    document.querySelectorAll("[data-sb-add]").forEach(function (b) { b.addEventListener("click", add); });
  }
  document.querySelectorAll(".sb-buy").forEach(initBuy);

  /* ---------- UGC videos: muted autoplay, one sound on at a time ---------- */
  var cards = document.querySelectorAll(".ugc-card");
  function setSound(card, on) {
    var v = card.querySelector("video"), b = card.querySelector(".snd"); if (!v || !b) return;
    v.muted = !on; b.setAttribute("aria-pressed", on ? "true" : "false"); b.setAttribute("aria-label", on ? "Turn sound off" : "Turn sound on");
    if (on) { try { v.currentTime = 0; } catch (e) {} v.play().catch(function () {}); }
  }
  cards.forEach(function (card) {
    var b = card.querySelector(".snd"); if (!b) return;
    b.addEventListener("click", function () {
      var on = card.querySelector("video").muted;
      cards.forEach(function (c) { if (c !== card) setSound(c, false); });
      setSound(card, on);
    });
  });
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); if (!v.muted) setSound(v.closest(".ugc-card"), false); }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll(".ugc-card video").forEach(function (v) { vio.observe(v); });
  }

  /* ---------- age tabs ---------- */
  document.querySelectorAll("[data-ages]").forEach(function (sec) {
    var panels = JSON.parse(sec.querySelector("[data-ages-data]").textContent);
    sec.querySelectorAll("[data-age]").forEach(function (b) {
      b.addEventListener("click", function () {
        var a = panels[+b.dataset.age];
        sec.querySelectorAll("[data-age]").forEach(function (o) { o.setAttribute("aria-selected", o === b ? "true" : "false"); });
        var im = sec.querySelector("[data-age-img]"); if (im && a.img) { im.src = a.img; im.alt = a.alt || ""; }
        sec.querySelector("[data-age-h]").textContent = a.h;
        sec.querySelector("[data-age-p]").textContent = a.p;
        sec.querySelector("[data-age-s]").textContent = a.s || "";
      });
    });
  });

  /* ---------- smooth anchors ---------- */
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-scroll]"); if (!s) return;
    var el = document.getElementById(s.dataset.scroll); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: "smooth", block: "start" }); }
  });
})();
